import { SelectOption } from "shared/components/Form/Select";
import {
  COLOR_GREY_5,
  COLOR_GREY_8,
  COLOR_ORANGE,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";
import { Category, TicketStatus } from "./types";

export const TICKET_STATUS_COLORS: Record<TicketStatus, string> = {
  [TicketStatus.Open]: COLOR_PRIMARY_MAIN,
  [TicketStatus.Processing]: COLOR_ORANGE,
  [TicketStatus.Answered]: COLOR_GREY_8,
  [TicketStatus.Closed]: COLOR_GREY_5,
};

export const inquiryTypeOptions: SelectOption[] = [
  { value: TicketStatus.Open, label: TicketStatus.Open },
  { value: TicketStatus.Processing, label: TicketStatus.Processing },
  { value: TicketStatus.Answered, label: TicketStatus.Answered },
  { value: TicketStatus.Closed, label: TicketStatus.Closed },
];

export const categories: Array<Category> = [
  {
    key: "Deposit/Withdraw",
    title: "{{cs_ticket.category.deposit_withdraw}}",
    subCategories: [
      { key: "Delay", title: "{{cs_ticket.category.deposit_withdraw.delay}}" },
      {
        key: "Cancel",
        title: "{{cs_ticket.category.deposit_withdraw.cancel}}",
      },
      {
        key: "First Deposit",
        title: "{{cs_ticket.category.deposit_withdraw.first_deposit}}",
      },
      {
        key: "How to",
        title: "{{cs_ticket.category.deposit_withdraw.how_to}}",
      },
    ],
  },
  {
    key: "My Account",
    title: "{{cs_ticket.category.my_account}}",
    subCategories: [
      { key: "Status", title: "{{cs_ticket.category.my_account.status}}" },
      { key: "Password", title: "{{cs_ticket.category.my_account.password}}" },
      {
        key: "VIP level",
        title: "{{cs_ticket.category.my_account.vip_level}}",
      },
      {
        key: "Change Information",
        title: "{{cs_ticket.category.my_account.change_information}}",
      },
      {
        key: "Close Account",
        title: "{{cs_ticket.category.my_account.close_account}}",
      },
    ],
  },
  {
    key: "Bets/Games",
    title: "{{cs_ticket.category.bets_games}}",
    subCategories: [
      { key: "Limits", title: "{{cs_ticket.category.bets_games.limits}}" },
      {
        key: "Cancellations",
        title: "{{cs_ticket.category.bets_games.cancellations}}",
      },
      {
        key: "Result Delays",
        title: "{{cs_ticket.category.bets_games.result_delays}}",
      },
      {
        key: "Resettlement",
        title: "{{cs_ticket.category.bets_games.resettlement}}",
      },
      {
        key: "Connectivity",
        title: "{{cs_ticket.category.bets_games.connectivity}}",
      },
      { key: "History", title: "{{cs_ticket.category.bets_games.history}}" },
    ],
  },
  {
    key: "Bonus/Promotions",
    title: "{{cs_ticket.category.bonus_promotions}}",
  },
  {
    key: "Partner",
    title: "{{cs_ticket.category.partner}}",
    subCategories: [
      { key: "Commission", title: "{{cs_ticket.category.partner.commission}}" },
      { key: "Level", title: "{{cs_ticket.category.partner.level}}" },
      { key: "Settlement", title: "{{cs_ticket.category.partner.settlement}}" },
      {
        key: "Move Player",
        title: "{{cs_ticket.category.partner.move_player}}",
      },
    ],
  },
  {
    key: "Other",
    title: "{{cs_ticket.category.other}}",
  },
];

export const defaultCategories = [
  "Bets/Games",
  "Bonus/Promotions",
  "Deposit/Withdraw",
  "My Account",
  "Other",
  "Partner",
] as const;
